export class LTG_ICONS {
    get_pack(packName) {
        return new Promise((res) => {
            const pack = LTG_ICONS.icons[packName];
            if (pack) {
                res(pack);
                return;
            }
            const data = new FormData();
            data.set('action', 'ltg_icons_get_list');
            data.set('icon_pack', packName);
            fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: data,
            }).then(res => res.json()).then(data => {
                LTG_ICONS.icons[packName] = data;
                res(data);
            });
        });
    }
}
LTG_ICONS.icons = {};
const IconCache = new LTG_ICONS();
export default IconCache;
